declare global {
  interface Window {
    fbq: any
  }
}

export const CHECKOUT_URL_MEGAPACK =
  'https://www.nerovix.online/cart/47984417145091:1'
export const CHECKOUT_URL_UPSELL =
  'https://www.nerovix.online/cart/47984425238787:1'

export const handleCheckoutMegapack = (e?: React.MouseEvent) => {
  if (e) {
    e.preventDefault()
  }

  // Fire Meta Pixel InitiateCheckout event
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout')
  }

  // Redirect to checkout
  window.location.href = CHECKOUT_URL_MEGAPACK
}

export const handleCheckoutUpsell = (e?: React.MouseEvent) => {
  if (e) {
    e.preventDefault()
  }

  // Fire Meta Pixel InitiateCheckout event
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout')
  }

  // Redirect to checkout
  window.location.href = CHECKOUT_URL_UPSELL
}

export const scrollToPurchase = (e?: React.MouseEvent) => {
  if (e) {
    e.preventDefault()
  }
  const el = document.getElementById('purchase')
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}
